const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
const { decode } = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getAuthentication(userId, password, dummySesKey, deviceInfo) {
      const url = getUrl('authenticate-pbOnline');
      const body = {
        uid: userId,
        pw1: password,
        seskey: dummySesKey,
        channel: deviceInfo != undefined ? deviceInfo : '',
      };
      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    getAuthorizeWebSSO(emailId) {
      const url = getUrl('authenticate-pbOnline');
      const body = {
        emailId: emailId
      };
      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    getDeviceValidation(userId, deviceId, deviceToken, channel) {
      const url = getUrl('validate-device');
      const body = { userId, deviceId, deviceToken, channel };
      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },
    getEncryptionKey(userId, type, metaData) {
      const url = getUrl('get-encryption-params-pbOnline');
      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };
      if (type != 'login') {
        var seskey = '';
        const parsedMetaData = parseRequestMetaData(metaData);
        seskey = parsedMetaData.info.sessionId;

        var body = {
          userId: userId,
          type: type,
          seskey: seskey
        };
      } else {
        var body = {
          userId: userId
        };
      }

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
    changePassword(password, metaData) {
      const url = getUrl('change-password-pbOnline');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        uid: parsedMetaData.qs.userId,
        pw1: password,
        seskey: parsedMetaData.info.sessionId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    getEnrollDevice(deviceId, metaData) {
      const url = getUrl('enroll-device');
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = { userId: parsedMetaData.qs.userId, deviceId };
      const reqOpts = { headers, method: 'POST', json: true };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parseRequestMetaData(metaData)
      ));
    },

    getDisenrollDevice(deviceId, metaData) {
      const url = getUrl('disenroll-device');
      const parsedMetaData = parseRequestMetaData(metaData);
      const qs = { userId: parsedMetaData.qs.userId, deviceId };
      const reqOpts = { headers, method: 'DELETE' };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, qs },
        parseRequestMetaData(metaData)
      ));
    },
  };
}

module.exports = apiFactory;